import { mountApp } from '@/apps/mount_app';
import ThemeLeaderboard from '@/components/devpost_homepage/ThemeLeaderboard.vue'

export default () => {
  mountApp({
    domId: "theme-leaderboard",
    component: ThemeLeaderboard
  })
}
